/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Risk categories */
export enum RiskCategory {
  Operational,
  Financial,
  Compliance,
  Security,
  Reputational,
  Technical,
  Legal,
}

export type RiskCategoryArgs = RiskCategory;

export function getRiskCategoryEncoder(): FixedSizeEncoder<RiskCategoryArgs> {
  return getEnumEncoder(RiskCategory);
}

export function getRiskCategoryDecoder(): FixedSizeDecoder<RiskCategory> {
  return getEnumDecoder(RiskCategory);
}

export function getRiskCategoryCodec(): FixedSizeCodec<
  RiskCategoryArgs,
  RiskCategory
> {
  return combineCodec(getRiskCategoryEncoder(), getRiskCategoryDecoder());
}
